<template>
  <div id="task__field__labels">
    <div class="field-block d-flex flex-row">
      <!-- <div slot="header" class="field-control-wrapper field-control-wrapper__title no-radius">
        <div @click.stop="sortTasks({sortKey: 'created_date', deliverables: fullDeliverables})" class="task-title">
          <div class="az task-table-header__task exclude-outside-click cursor-pointer" :class="$store.state.deliverables.storedSortKey == 'created_date' ? `${$store.state.deliverables.storedSortState}-created-date` : ''">
              Tasks <span class="task-count-second">({{tasks.length}})</span> 
              <b-button v-if="!(!userAbilities.editMediaCall || deliverable.permissions.viewOnly)" variant="theme" class="add-task-btn" @click.stop="createTask">
                  Add Task
                  <div role="status" v-show="addingTask" class="ml-2 spinner-border spinner-border-sm text-primary"><span class="sr-only">Loading...</span></div>
              </b-button>
              <SortTaskControl />
          </div>
        </div>
      </div> -->
      <draggable v-model="taskFieldOrder" draggable=".draggable-field" class="d-flex flex-row sortable--fields" filter=".no-draggable-field" :move="checkMoveField" @update="moveField" handle=".field-move-handle" :disabled="true">
        <div slot="header" class="field-control-wrapper field-control-wrapper__title no-radius no-draggable-field">
          <!-- <div @click.stop="sortTasks({sortKey: 'created_date', deliverables: fullDeliverables})" class="task-title"> -->
          <div class="task-title">
            <div class="az task-table-header__task exclude-outside-click cursor-pointer" :class="$store.state.deliverables.storedSortKey == 'created_date' ? `${$store.state.deliverables.storedSortState}-created-date` : ''">
                Tasks <span class="task-count-second">({{tasks.length}})</span> 
                <b-button v-if="!(!userAbilities.editMediaCall || deliverable.permissions.viewOnly)" variant="theme" class="add-task-btn" @click.stop="createTask">
                    Add Task
                    <div role="status" v-show="addingTask" class="ml-2 spinner-border spinner-border-sm text-primary"><span class="sr-only">Loading...</span></div>
                </b-button>
                <!-- <SortTaskControl /> -->
            </div>
          </div>
        </div>
        <!-- <div @click="sortTasks({fieldId: taskField.field_id, sortKey: sortEnabledFields[sortEnabledFields.indexOf(taskField.field_key)], deliverables: fullDeliverables})" 
        v-for="(taskField, index) in tasks[0].taskFields" 
        :key="`${taskField.field_key}_${taskField.field_id}${index}`"
        class="d-none d-lg-block field-rows field-control-wrapper draggable-field" 
        :class="getClasses(taskField)"> -->
        <div v-for="(taskField, index) in tasks[0].taskFields" 
        :key="`${taskField.field_key}_${taskField.field_id}${index}`"
        class="d-none d-lg-block field-rows field-control-wrapper draggable-field" 
        :class="getClasses(taskField)">
          <div class="task-table-header" :class="getSortingClass(taskField.field_id)">
            <div class="field-label cursor-pointer">
              <!-- <a class="field-move-handle">
                <i class="fas fa-arrows-alt"></i>
              </a> -->
              <div v-if="taskField.label_id !== null">
                <NewCustomFieldLabel :customField="taskField" :taskCount="tasks.length" :deliverableId="deliverableId"/>
              </div>
              <span v-else>
                {{ taskField.label }}
                <!-- <SortTaskControl v-if="sortEnabledFields.indexOf(taskField.field_key) != -1" /> -->
              </span>
            </div>
          </div>
        </div>
      </draggable>
    </div>
    <AdditionalFields :deliverableType="deliverable.deliverable_template_id" :deliverableId="deliverableId" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import SortTaskControl from '../common/SortTaskControl'
import NewCustomFieldLabel from '../common/NewCustomFieldLabel'
import AdditionalFields from '../common/AdditionalFields'
export default {
  data() {
    return {
      addingTask: false,
      sortEnabledFields: ['status', 'status_note', 'user', 'due_date', 'request']
    }
  },
  props: {
    fullDeliverables: '',
    tasks: Array,
    deliverableId: '',
    deliverable: Object
  },
  computed: {
    ...mapGetters(['userAbilities']),
    taskFieldOrder: {
      get: function() {
      	if (this.tasks[0]) {
	        let orgTaskFields = Object.assign([], this.tasks[0].taskFields);
	        orgTaskFields.unshift(1);
	        return orgTaskFields;
      	}
      	return [];
      }, 
      set: function(newValue) {
        newValue.shift();
        if (this.tasks[0]) {
	        this.tasks[0].taskFields = newValue
	      }
      }
    }
  },
  components: {
    draggable,
    SortTaskControl,
    AdditionalFields,
    NewCustomFieldLabel
  },
  methods: {
    moveField() {
      this.taskFieldOrder.shift();
      this.$store.dispatch('saveTaskFieldOrder', {fieldOrderData: this.taskFieldOrder, deliverableId: this.deliverableId, deliverableTemplateId: this.deliverable.deliverable_template_id})
    },
    getSortingClass(fieldId) {
      // Hardcode return no active sort
      return '';

      let currentSortFieldId = localStorage.getItem('storedSortFieldId')
      let currentSortState = localStorage.getItem('storedSortState')
      return fieldId == currentSortFieldId ? `sort-active ${currentSortState}-${currentSortFieldId}` : ''
    },
    getClasses(task) {
      let classes = ''
      if (task) {
        classes = `field-control-wrapper__${task.field_key} toggleTaskField__${task.id}`;
      }
      return classes;
    },
    createTask() {
      let self = this;
      this.addingTask = true;
      this.$store.dispatch("createTask", this.deliverableId).then(function(r) {
        self.addingTask = false;
        self.$store.dispatch('manageUndoActivationNoScroll', 'Task has been created.');

        // Focus on task title
        if (r) {
          let newTaskId = r;
          self.$nextTick(() => {
            console.log(newTaskId);
            $(`.field-value.exclude-outside-click.text-hover-bg.task__title__${newTaskId}`).trigger('click');
            
            if ($('#editDeliverableModal').length) {
              $(`#editDeliverableModal .field-value.exclude-outside-click.text-hover-bg.task__title__${newTaskId}`).siblings(".custom-field").find(".form-control.title-field")[0].select();
            } else if ($('#editDeliverableModalAlert').length) {
              $(`#editDeliverableModalAlert .field-value.exclude-outside-click.text-hover-bg.task__title__${newTaskId}`).siblings(".custom-field").find(".form-control.title-field")[0].select();
            } else {
              $(`.field-value.exclude-outside-click.text-hover-bg.task__title__${newTaskId}`).siblings(".custom-field").find(".form-control.title-field")[0].select();
            }
          });
        }
      });
    },
    checkMoveField(e) {
      e.related.className.indexOf('no-draggable-field') === -1;
    }
  }
}
</script>

<style lang="scss">
  .task-fields {
    // .field-control-wrapper:nth-child(2) {
    //   text-align: center;
    // }
  }
  #task__field__labels {
    .sortable--fields {
      flex: auto;
      .field-control-wrapper:first-child.draggable-field {
        text-align: center;
      }
    }
    .task-table-header.sort-active {
        background-color: #fff4b4;
        &.ASC-2,
        &.ASC-4, 
        &.ASC-12,
        &.ASC-13,
        &.ASC-14 {
            .fa-sort {
                &:before {
                    content: "\F0DE";
                }
            }
        }
        &.DESC-2,
        &.DESC-4,
        &.DESC-12,
        &.DESC-13,
        &.DESC-14 {
            .fa-sort {
                &:before {
                    content: "\F0DD";
                }
            }
        }
    }
    .task-table-header__task,
    .task-table-header {
      border-bottom: unset;
      .field-label {
        font-weight: 700;
      }
    }
  }
  .task-fields {
    .task-table-header__task,
    .task-table-header {
      display: none;
    }
  }
</style>